export const Required = () => {
  return <span className="text-red-600">*</span>;
};
